/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'myTeam': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M959.6 815.1c0 11.2-3.2 26.2-3.2 37.4h-64.1c3.2-11.2 3.2-26.2 3.2-37.4 0-145.7-99.3-261.5-224.2-261.5v-74.7c54.5 0 96.1-48.6 96.1-112.1 0-56-35.2-104.6-80.1-112.1l9.6-74.7c76.9 11.2 134.5 89.7 134.5 183 0 56-19.2 104.6-51.2 138.2 105.7 48.7 179.4 168.2 179.4 313.9zM543.2 538.6c131.3 59.8 224.2 209.2 221 384.8v37.4h-64.1c3.2-11.2 3.2-26.1 3.2-37.4 0-186.8-128.1-336.2-288.3-336.2-160.2 0-288.3 149.4-288.3 336.2v37.4h-64v-37.4c0-175.6 92.9-325 224.2-384.8-57.7-44.8-96.1-123.3-96.1-212.9C190.8 180 290.1 64.2 415 64.2S639.3 180 639.3 325.7c0 85.9-38.5 164.4-96.1 212.9zM415 138.9c-89.7 0-160.2 82.2-160.2 186.8 0 104.6 70.5 186.8 160.2 186.8 89.7 0 160.2-82.2 160.2-186.8 0-104.6-70.5-186.8-160.2-186.8z" _fill="#111"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/myTeam.js